// extracted by mini-css-extract-plugin
module.exports = {"buttonsFooter":"AddStockItem_buttonsFooter__3guY9"};